// extracted by mini-css-extract-plugin
export default {"jdPowerDialogFullscreen":"_jd-power_jdPowerDialogFullscreen__Zp7An"};